import React from 'react';
import { resetInvalidInputField } from "../../helpers/ComponentHelper";

// odczyt wg ścieżki np. "accidentRates.0.rate"
const getByPath = (obj, path) => {
  return path.split('.').reduce((o, p) => (o ? o[p] : undefined), obj);
};

// zapis wg ścieżki
const setByPath = (obj, path, value) => {
  const parts = path.split('.');
  const last = parts.pop();
  const newObj = { ...obj };
  let cur = newObj;
  for (const p of parts) {
    if (Array.isArray(cur[p])) {
      cur[p] = [...cur[p]];
    } else {
      cur[p] = { ...cur[p] };
    }
    cur = cur[p];
  }
  cur[last] = value;
  return newObj;
};

const NumberInputNested = ({ propertyName, state, required, min, max, disabled, color }) => {
  const currentItem = state.currentItem;
  const setCurrentItem = state.setCurrentItem;
  const currentFormState = state.currentFormState;
  const setCurrentFormState = state.setCurrentFormState;
  const itemChanged = state.itemChanged;
  const setItemChanged = state.setItemChanged;

  const currentValue = getByPath(currentItem, propertyName) ?? 0;

  return (
    <input
      style={{ backgroundColor: color }}
      type="number"
      id={propertyName}
      name={propertyName}
      min={min}
      max={max}
      defaultValue={currentValue}
      className="form-control"
      required={required}
      disabled={disabled}
      onChange={(e) => {
        const newValue = parseFloat(e.target.value);
        setItemChanged(!itemChanged);
        setCurrentItem(prev => setByPath(prev, propertyName, newValue));
        setCurrentFormState({ ...currentFormState, formSaveButtonDisabled: false });
      }}
      onClick={() => resetInvalidInputField(propertyName)}
    />
  );
};

export default NumberInputNested;
